import Styles from '../../../Styles';
import {StyleSheet, View} from 'react-native';
import AVText from '../../AVText';
import {checkValue} from '../../../../Util';
import React from 'react';

type NutritionRowProps = {
  label: string;
  value: number;
  unit: string;
  dailyValue?: number;
  bold?: boolean;
  indented?: boolean;
};

export const NutritionRow = ({
  label,
  value,
  unit,
  dailyValue,
  bold = false,
  indented = false,
}: NutritionRowProps) => {
  const textStyle = bold ? styles.amtPerServingText : styles.amtPerServingValue;
  const containerStyle = indented
    ? [styles.fullInformationRow, {marginLeft: Styles.Spacing.m4}]
    : styles.fullInformationRow;

  return (
    <View style={containerStyle}>
      <View style={styles.column}>
        <View style={styles.row}>
          <AVText
            style={textStyle}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
          >
            {label}
          </AVText>
          <AVText
            style={styles.amtPerServingValue}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
          >
            {value} {unit}
          </AVText>
        </View>
      </View>
      {checkValue(dailyValue) && (
        <View style={styles.column}>
          <AVText
            style={styles.amtPerServingText}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
          >
            {dailyValue} %
          </AVText>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  fullInformationRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: Styles.Spacing.m1,
  },
  row: {
    flexDirection: 'row',
    paddingVertical: 2.5,
  },
  column: {
    flexDirection: 'column',
  },
  amtPerServingText: {
    paddingTop: 5,
    fontWeight: '700',
  },
  amtPerServingValue: {
    paddingTop: Styles.Spacing.m1,
    marginHorizontal: Styles.Spacing.m1,
  },
});
